import { MutableRefObject } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { ModalSection } from '~/components/common';

import { useClaimStore } from '~/store';

import ClaimReturnRegisterSecondStepDefaultInfo from './ClaimReturnRegisterSecondStepDefaultInfo/ClaimReturnRegisterSecondStepDefaultInfo';
import ClaimReturnRegisterSecondStepReturnGoodsTable from './ClaimReturnRegisterSecondStepReturnGoodsTable/ClaimReturnRegisterSecondStepReturnGoodsTable';
import ClaimReturnRegisterSecondStepReturnInfo from './ClaimReturnRegisterSecondStepReturnInfo/ClaimReturnRegisterSecondStepReturnInfo';

import type { TypeReturnRegisterSecondStepValues, TypeReturnRegisterSecondStepValuesState } from '~/types/claim.types';

import styles from './ClaimReturnRegisterSecondStepContent.module.scss';

const ClaimReturnRegisterSecondStepContent = ({
  errorFieldRefs,
}: {
  errorFieldRefs: MutableRefObject<Record<string, HTMLElement | null>>;
}) => {
  const [returnInfoValues, returnInfoValuesState, setReturnInfoValues, setReturnInfoValuesState] = useClaimStore(
    useShallow((state) => [
      state.returnRegisterSecondStepValues,
      state.returnRegisterSecondStepValuesState,
      state.actions.setReturnRegisterSecondStepValues,
      state.actions.setReturnRegisterSecondStepValuesState,
    ])
  );

  const handleChangeReturnInfoValues = (values: Partial<TypeReturnRegisterSecondStepValues>) => {
    setReturnInfoValues({ ...returnInfoValues, ...values });
  };

  const handleChangeReturnInfoValuesState = (values: Partial<TypeReturnRegisterSecondStepValuesState>) => {
    setReturnInfoValuesState({ ...returnInfoValuesState, ...values });
  };

  return (
    <div className={styles['content-container']}>
      <ClaimReturnRegisterSecondStepDefaultInfo
        data={returnInfoValues}
        dataState={returnInfoValuesState}
        onChange={handleChangeReturnInfoValues}
        onChangeState={handleChangeReturnInfoValuesState}
        errorFieldRefs={errorFieldRefs}
      />
      <ClaimReturnRegisterSecondStepReturnInfo
        data={returnInfoValues}
        dataState={returnInfoValuesState}
        onChange={handleChangeReturnInfoValues}
        onChangeState={handleChangeReturnInfoValuesState}
        errorFieldRefs={errorFieldRefs}
      />
      <ModalSection className={styles['return-orders']} title="반품 상품">
        <ClaimReturnRegisterSecondStepReturnGoodsTable
          data={returnInfoValues.returnOrderItems}
          dataState={returnInfoValuesState.returnOrderItems}
          onChange={handleChangeReturnInfoValues}
          onChangeState={handleChangeReturnInfoValuesState}
        />
      </ModalSection>
    </div>
  );
};

export default ClaimReturnRegisterSecondStepContent;
